let defaults = {
    DISABLE_AUTO_DRIVE_ACTIONS: false,
    DISABLE_APPCACHE_RELOAD: false,
    DISABLE_SERVICEWORKER_RELOAD: false,
    LOG_EVENTS_TO_CONSOLE: false,
    ALLOW_LOGOUT_WHILE_DRIVING: false,
    DISABLE_SSL: false,
    ENABLE_AUTO_ASSIGN: false,
    DISABLE_AVAILABILITY_ALERTS: false,
    ENABLE_ELD_TEST_TRANSFER: false,
    ELD_TRANSFER_VALIDATE_ONLY: false,
    ELD_DTC_TRANSFER_FAIL: false,
    SERVERCALL_NO_CONNECTION: false,
    SERVERCALL_TEST: undefined,
    DISABLE_SYNC_FAILURE_DELAY: false,
    ENABLE_LOGGING: false
};
let action = {
    SAMPLE_FN: function () {
        // Do something
    }
};

export function initDebugMode () {
    if (!window.DRIVE_DEBUG) {
        window.DRIVE_DEBUG = {};
    }

    for (let key in defaults) {
        if (defaults.hasOwnProperty(key)) {
            if (!window.DRIVE_DEBUG.hasOwnProperty(key)) {
                window.DRIVE_DEBUG[key] = defaults[key];
            }
        }
    }
}

export function getDebugState () {
    return window.DRIVE_DEBUG;
}

export function getDebugFlag(key) {
    if (!defaults.hasOwnProperty(key)) {
        throw new Error("Debug flag does not exist");
    }

    return (window.DRIVE_DEBUG || {})[key];
}

export function toggleDebugFlag (key) {
    if (defaults.hasOwnProperty(key)) {
        let debugFlags = window.DRIVE_DEBUG || {};

        debugFlags[key] = debugFlags[key] === false;
        if (typeof action[key] === "function") {
            action[key](debugFlags[key]);
        }
        return debugFlags[key];
    }
    throw new Error("DEBUG: Can't toggle an invisible switch");
}